<template>
  <div class="right-content clearfix">
    <view-container :loading="loading" :empty="empty || !list.length" :error="error" @retry="loadData">
      <ul>
        <li v-for="(item, index) in list" :key="index">
          <span>{{item.ancestors && item.ancestors[0] && item.ancestors[0].name || '-'}}</span>
          <p>
            <router-link :to="{ name: 'NoticeDetail', query: {ruleId: item.ruleId, categoryId: categoryId, childCategoryId: childCategoryId}}">
              {{item.title}}
            </router-link>
          </p>
          <span>{{moment(item.operationTimestamp)}}</span>
        </li>
      </ul>
    </view-container>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import viewContainer from '@/components/viewContainer'
export default {
  name: '',
  data () {
    return {
      loading: false,
      empty: false,
      error: false,
      pageModal: {
        pageNo: 1,
        pageSize: 12
      }
    }
  },
  computed: {
    ...mapState({
      list: 'noticeList',
      categoryId: 'categoryId',
      childCategoryId: 'childCategoryId'
    })
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      const {
        pageNo,
        pageSize
      } = this.pageModal
      this.loading = true
      this.empty = false
      this.error = false
      this.getNoticeOverview({
        pageNo,
        pageSize
      }).then(() => {
        if (!this.list || !this.list.length) {
          this.empty = true
        }
      }).catch(() => {
        this.error = true
      }).finally(() => {
        this.loading = false
      })
    },
    ...mapActions({
      getNoticeOverview: 'getNoticeOverview'
    }),
    moment (val) {
      return moment(val).format('YYYY.MM.DD')
    }
  },
  components: {
    viewContainer
  }
}
</script>

<style lang="scss" scoped>
ul {
  float: left;
  width: 100%;
  li {
    float: left;
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 15px;
    overflow: hidden;
    position: relative;
    > span:first-child {
      float: left;
      font-size: 12px;
      color: #627DB6;
      background: rgba($color: #627DB6, $alpha: 0.1);
      border-radius: 2px;
      padding: 2px 4px;
      line-height: 14px;
    }
    p  {
      padding-left: 10px;
      overflow:hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-right: 130px;
    }
    > span:nth-child(3) {
      position: absolute;
      top: 0;
      right: 30px;
      font-size: 14px;
      color: #999;
      font-weight: 400;
    }
  }
}
</style>
